import React, { useState, useEffect, useCallback } from 'react';
import { withAuth as withOktaAuth } from '@okta/okta-react';

import './OktaLoggedInAs.css';

const OktaLoggedInAs = ({ auth: oktaAuth }) => {
  const [loggedInUser, setLoggedInUser] = useState(null);

  const setOktaUser = useCallback(async () => {
    const oktaUser = await oktaAuth.getUser();
    setLoggedInUser(oktaUser);
  }, [oktaAuth]);

  useEffect(() => {
    setOktaUser();
  }, [setOktaUser]);

  return (
    <div className="OktaLoggedInAs">
      {loggedInUser ? (
        <>
          Logged in as <strong>{loggedInUser.name}</strong>. (
          <a href="/oauth/login">re-login</a>)
        </>
      ) : (
        <>Loading....</>
      )}
    </div>
  );
};

export default withOktaAuth(OktaLoggedInAs);
